const commentsStyle = Object.freeze({
  textInputVariant: 'primary',
  sendButtonVariant: 'primary',
  formFontStack: 'alt',
});

export default commentsStyle;
